import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { ApplicationConfig } from '@angular/core';
import { provideLuxonDateAdapter } from '@angular/material-luxon-adapter';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_RADIO_DEFAULT_OPTIONS } from '@angular/material/radio';
import { provideRouter, TitleStrategy, withPreloading } from '@angular/router';
import { CustomPreloadingStrategy, provideBfyUiShared, Site } from '@bfy/bfy-ui-shared';
import { appRoutes } from './app.routing';
import { PrefixTitleStrategy } from './util/prefix-title-strategy';

export const appConfig: ApplicationConfig = {
    providers: [
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: { appearance: 'outline' },
        },
        { provide: MAT_RADIO_DEFAULT_OPTIONS, useValue: { color: 'primary' } },
        { provide: TitleStrategy, useClass: PrefixTitleStrategy },
        provideLuxonDateAdapter(),
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
        provideBfyUiShared({
            site: Site.Registration,
        }),
        provideRouter(appRoutes, withPreloading(CustomPreloadingStrategy)),
    ],
};
